let tabmenu = document.querySelector(".application-tabmenu-group");
let toolbarContainer = document.querySelector(".js-toolbar-container");
if(document.querySelector(".js-open-variables")) {document.querySelector(".js-open-variables").disabled = false;}
if(document.querySelector(".js-open-tree")) {document.querySelector(".js-open-tree").disabled = false;}

let sdModal;
document.addEventListener("DOMContentLoaded", function(){
    sdModal = document.getElementsByClassName("sd-modal");
});



function clean(node) {
    for (var n = 0; n < node.childNodes.length; n ++) {
        var child = node.childNodes[n];
        if (child.nodeType === 8 || (child.nodeType === 3 && !/\S/.test(child.nodeValue))) {
            node.removeChild(child);
            n --;
        } else if(child.nodeType === 1) {
            clean(child);
        }
    }
}
clean(document);

if(tabmenu)
    tabmenu.addEventListener("click", function(event){
        document.querySelector('.sd-sensitivity-analysis-dialog').classList.remove("open");
        if(event.target.classList.contains("js-open-variables")){
            document.querySelector('.application-edit').style.display = "none";
            document.getElementById("mouse-actions-box").hidden = true;
            document.getElementById("mouse-actions-widget").hidden = true;
        }
        else if(event.target.classList.contains("js-open-tree")){
            var tabs = Array.from(document.getElementsByClassName('tab'));
            var currentTabIndex = tabs.findIndex(tab => tab.classList.contains("selected"));
            var tutorialDisplayStatus = JSON.parse(sessionStorage.getItem("tutorial_display_status"));
            if(tutorialDisplayStatus !== null){
                var displayTutorial = tutorialDisplayStatus[currentTabIndex].split(",")[0]
                if(displayTutorial === "true"){
                    document.getElementById("interactive-tutorial").hidden = false;
                }
            }
            document.querySelector('.application-edit').style.display = "flex";
            document.getElementById("mouse-actions-widget").hidden = false;
        }
        /*if(event.target.classList.contains("js-open-sensitivity")){
            document.querySelector('#sd-definitions-dialog').classList.remove("open")
            document.querySelector('#sd-definitions-dialog').classList.add("hide")
            document.querySelector('.application-edit').style.display = "none"
        }*/

        document.querySelector('#object-properties').classList.remove('visible');
        document.querySelector('#sd-definitions-dialog').classList.add("hide")
        let target = event.target.parentNode;
        if (event.target.classList.contains('material-icons-outlined')) {
            target = target.parentNode;
        }
        let c = 0;

        while(c < tabmenu.childNodes.length){
            tabmenu.childNodes[c++].classList.remove("active");
            document.querySelector('#sd-definitions-dialog').classList.remove("hide")
        }
        target.classList.add("active");



        if(target.classList.contains("js-modal-open")){
            toolbarContainer.classList.add("hide");

        }else{
            toolbarContainer.classList.remove("hide");
            for(let i = 0; i < sdModal.length; i++){
                sdModal[i].classList.remove("open");
            }
        }

    });



// WEBPACK FOOTER //
// ./scripts/components/tab-menu.js